import AssistantIcon from '@mui/icons-material/Assistant'
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'

export const BillPayUnavailable = () => (
  <Box
    sx={{
      flexDirection: 'column',
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      px: 3,
      py: { xs: 0, md: 2 },
      textAlign: 'center',
    }}
  >
    <PaymentsOutlined fontSize="large" color="primary" />
    <Typography variant="h5" gutterBottom>
      Bill Pay is not available
    </Typography>
    <Typography variant="body1" sx={{ maxWidth: 440 }}>
      Bill Pay is not configured for your organization yet.
    </Typography>
    <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
      <Button
        component={Link}
        to="/ask-ai"
        variant="contained"
        startIcon={<AssistantIcon />}
      >
        Go to chat
      </Button>
    </Stack>
    <Typography variant="caption" color="textSecondary" sx={{ mt: 2 }}>
      Contact your account team to request access.
    </Typography>
  </Box>
)
